import React, { useEffect, useRef } from 'react';

// AdSense side banner component
export default function AdBannerSide({ position = "left", style = {}, slot = "3575926907337417" }) {
  const adRef = useRef();

  useEffect(() => {
    if (window.adsbygoogle && adRef.current) {
      try {
        window.adsbygoogle.push({});
      } catch (e) {}
    }
  }, []);

  // Only show on desktop (min-width: 900px)
  const baseStyle = {
    position: 'fixed',
    top: 220, // Increased to avoid SessionInfoBox
    [position]: 0,
    zIndex: 1000, // Lowered so SessionInfoBox is always on top
    width: 160,
    minHeight: 600,
    display: 'none',
  };

  // Responsive: show only full screen on desktop
  const responsiveStyle = `@media (min-width: 1900px) { .adsbygoogle-side-${position} { display: block !important; } }`;

  return (
    <>
      <style>{responsiveStyle}</style>
      <div className={`adsbygoogle-side-${position}`} style={{ ...baseStyle, ...style }}>
        <ins
          className="adsbygoogle"
          style={{ display: 'block', width: '160px', minHeight: '600px' }}
          data-ad-client="ca-pub-3575926907337417"
          data-ad-slot={slot}
          data-ad-format="vertical"
          ref={adRef}
        ></ins>
      </div>
    </>
  );
}
